import removeSubstring from '../../utils/removeSubstring';

const COMMON_STREETNAME_SYNONYMS = [
  {
    original: 'highway',
    transformed: 'hwy',
  },
  {
    original: 'mount',
    transformed: 'mt',
  },
];

export default function getCleanFirstStreetWord(streetName: string): string {
  const firstWord = streetName.split(' ')[0];

  let cleanedFirstWord = removeSubstring(firstWord, "'"); // Remove any potential apostrophes (eg. Leanne's)
  cleanedFirstWord = removeSubstring(cleanedFirstWord, '.'); // Remove any potential periods (eg. St. Clair)
  cleanedFirstWord = cleanedFirstWord.toLowerCase();

  COMMON_STREETNAME_SYNONYMS.forEach(synonym => {
    cleanedFirstWord = cleanedFirstWord.replace(
      synonym.original,
      synonym.transformed,
    );
  });

  return cleanedFirstWord;
}
